import { defineComponent as _defineComponent } from 'vue'
import ResourceCard from './ResourceCard.vue'
import FormLayout from '../common/FormLayout.vue'
import VsWrapper from '@/components/vision/VsWrapper.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ResourcePickerList',
  props: {
    title: null,
    resourceIds: null
  },
  emits: ["dismiss"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'dismiss')
}), expose: any, slots: any, attrs: any }) {





const handleDismiss = () => {
  emits('dismiss')
}

return { __sfc: true,emits, handleDismiss, ResourceCard, FormLayout, VsWrapper }
}

})